/* flow */

import arrow from '!raw-loader!../img/arrow-up.svg';
import chevron from '!raw-loader!../img/chevron.svg';
import cube from '!raw-loader!../img/cube.svg';
import facebookLogo from '!raw-loader!../img/facebook.svg';
import hero from '../img/Root100_2018_desktop.jpg';
import link from '!raw-loader!../img/link.svg';
import marker from '!raw-loader!../img/marker.svg';
import menu from '!raw-loader!../img/menu.svg';
import megaphone from '!raw-loader!../img/megaphone.svg';
import mobileHero from '../img/Root100_2018_mobile.jpg';
import rootIcon from '../img/root.png';
import rootIconAlt from '../img/root_sm.png';
import rootLogo from '!raw-loader!../img/logo.svg';
import root1002019Logo from '../img/root-100-2019-logo.png';
import root1002019LogoBlack from '../img/root100_2019_logo_blackbackground_comp.png';
import rotate from '!raw-loader!../img/rotate-ccw.svg';
import search from '!raw-loader!../img/search.svg';
import share from '!raw-loader!../img/share.svg';
import sort from '!raw-loader!../img/sort.svg';
import twitterLogo from '!raw-loader!../img/twitter.svg';
import trophy from '!raw-loader!../img/trophy.svg';
import toyotaLogo from '../img/toyota.png';

const imagePath = ''; // /kinja-static-features';

export {
	arrow,
	chevron,
	cube,
	facebookLogo,
	hero,
	imagePath,
	link,
	marker,
	menu,
	megaphone,
	mobileHero,
	rootIcon,
	rootIconAlt,
	rootLogo,
	root1002019Logo,
	root1002019LogoBlack,
	rotate,
	search,
	share,
	sort,
	twitterLogo,
	toyotaLogo,
	trophy
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/images.js